import { render, staticRenderFns } from "./CreateOfferPage.vue?vue&type=template&id=f574f466&"
import script from "./CreateOfferPage.vue?vue&type=script&lang=ts&"
export * from "./CreateOfferPage.vue?vue&type=script&lang=ts&"
import style0 from "./CreateOfferPage.vue?vue&type=style&index=0&id=f574f466&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports